function IconChevronLeft() {
  return (
    <svg viewBox="0 0 30 30" width={30} height={30}>
      <path d="M20,3L8,15l12,12" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
    </svg>
  );
}

export default IconChevronLeft;
